import { useRecoilState } from 'recoil';

import { Button, Heading, Icon, Modal, Paragraph } from '@zillow/constellation-10';
import { IconCheckmarkCircleFilled } from '@zillow/constellation-icons';

import { isSigningCompleteModalOpenState } from '../../../../atoms';

export function SigningCompleteModal() {
  const [isSigningCompleteModalOpen, setIsSigningCompleteModalOpen] = useRecoilState(isSigningCompleteModalOpenState);

  function onSigningCompleteModalClose(): void {
    setIsSigningCompleteModalOpen(false);
  }

  return (
    <Modal
      size={{ base: 'fullScreen', md: 'xs' }}
      open={isSigningCompleteModalOpen}
      onOpenChange={(open) => {
        if (!open) {
          onSigningCompleteModalClose();
        }
      }}
      header={<Heading level={1}>Signing complete</Heading>}
      body={
        <>
          <Icon size="lg" role="img" css={{ marginBottom: 'tight', color: 'icon.feedback.success.strong' }}>
            <IconCheckmarkCircleFilled />
          </Icon>
          <Heading level={2} css={{ textStyle: 'responsive.heading-xs', marginBottom: 'tight' }}>
            You’ve finished signing
          </Heading>
          <Paragraph>
            We’ll notify you once everyone signs so you can download your signed lease renewal agreement.
          </Paragraph>
        </>
      }
      footer={
        <Button tone="brand" emphasis="filled" onClick={onSigningCompleteModalClose}>
          OK
        </Button>
      }
    />
  );
}
